<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<template>
  <div class="page-title">
    <i class="fa-solid fa-container-storage"></i>
    <span class="space-icon"></span>
    {{ container.container_code }}
    <span
      :class="[
        'px-2 py-1 text-xs font-medium rounded-full text-white',
        container.org_invoices_paid ? 'bg-green-500' : 'bg-red-500'
      ]"
    >
      {{ container.org_invoices_paid ? "Pagado" : "No pagado" }}
    </span>
  </div>
  <div class="panel">
    <div class="panel-body">
      <div class="divide-gray-200">
        <div class="grid grid-cols-1 gap-y-8 gap-x-4 sm:grid-cols-6">
          <div class="sm:col-span-2">
            <dt class="label-data">
              {{ $t("model.container.week") }}
            </dt>
            <dd class="content-data">
              {{ container.week }}
            </dd>
          </div>
          <div class="sm:col-span-2">
            <dt class="label-data">{{ $t("model.container.customer") }}:</dt>
            <dd class="content-data">{{ container.customer?.name }}</dd>
          </div>
          <div class="sm:col-span-2">
            <dt class="label-data">
              {{ $t("model.container.exporter_process_brand") }}:
            </dt>
            <dd class="content-data">
              {{ container?.brand_name }}
            </dd>
          </div>
          <div class="sm:col-span-2">
            <dt class="label-data">{{ $t("model.container.provider") }}:</dt>
            <dd class="content-data">
              {{ container.provider_names.join(' | ') }}
            </dd>
          </div>
          <div class="sm:col-span-2">
            <dt class="label-data">{{ $t("model.container.waybill") }}:</dt>
            <dd class="content-data">{{ container.waybill }}</dd>
          </div>
        </div>
      </div>
    </div>
    <div
      class="panel-footer"
      v-if="Object.keys(container_attachments).length > 0"
    >
      <div class="panel-footer-actions">
        <template v-for="key in Object.keys(container_attachments)">
          <template
            v-for="(container_attachment, index) in container_attachments[key]"
            :key="container_attachment.id"
          >
            <span class="space-actions"></span>
            <button
              type="button"
              @click.prevent="downloadContainerAttachment(container_attachment)"
              class="btn-white"
            >
              <i
                :class="[
                  'fa-solid',
                  container_attachment.downloading
                    ? 'fa-sync fa-spin'
                    : 'fa-download'
                ]"
              ></i>
              <span class="space-icon"></span>
              {{ filename(container_attachment) }}
              <span v-if="container_attachments[key].length > 1">
                ({{ index + 1 }})
              </span>
            </button>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/finances/query_container_outcomes/show_container.js";

export default {
  name: "AEFinancesQueryContainerIncomesContainerInfo",
  props: {
    agro_exporter_id: { required: true },
    container: {
      type: Object,
      required: true
    }
  },
  computed: {
    container_attachments() {
      return this.container.container_attachments;
    }
  },
  methods: {
    downloadContainerAttachment: async function (container_attachment) {
      container_attachment.downloading = true;
      try {
        let response = await Requester.downloadContainerAttachment(
          this.agro_exporter_id,
          this.container.id,
          container_attachment.id
        );

        const file = response.data;
        this.downloadFile(file, container_attachment.filename);
      } catch (error) {
        error;
      }
      container_attachment.downloading = false;
    },
    filename(container_attachment) {
      let name = container_attachment.exporter_process_container_file.name;
      if (container_attachment.provider_name)
        name += ` - ${container_attachment.provider_name}`;
      return name;
    }
  }
};
</script>
